class ReflexEvents {
  /////////////////////////////////////////////////////////
  //
  //
  /////////////////////////////////////////////////////////
  constructor() {
    this._events = {};
  }
  /////////////////////////////////////////////////////////
  // Supports multiple events space-separated
  //
  /////////////////////////////////////////////////////////
  on(events, fct) {
    events.split(" ").forEach((event) => {
      this._events[event] = this._events[event] || [];
      this._events[event].push(fct);
    });
    return this;
  }
  /////////////////////////////////////////////////////////
  // Supports multiple events space-separated
  //
  /////////////////////////////////////////////////////////
  off(events, fct) {
    if (events == void 0) {
      this._events = {};
      return;
    }
    events.split(" ").forEach((event) => {
      if (event in this._events === false) return;
      if (fct) {
        this._events[event].splice(this._events[event].indexOf(fct), 1);
      } else {
        this._events[event] = [];
      }
    });
    return this;
  }
  /////////////////////////////////////////////////////////
  //
  //
  /////////////////////////////////////////////////////////
  emit(event) {
    if (this._events[event] === void 0) return;
    const tmpArray = this._events[event].slice();
    for (let i = 0; i < tmpArray.length; ++i) {
      const result = tmpArray[i].apply(
        this,
        Array.prototype.slice.call(arguments, 1)
      );
      if (result !== void 0) {
        return result;
      }
    }
    return void 0;
  }
}
export default ReflexEvents;
